export type ObservationType = "blood-pressure" | "weight" | "glucose" | "heart-rate" | "height" | "unknown";

export const getObservationType = <T extends { unit: string }>(measurements: T[]): ObservationType => {
  if (
    (measurements.length === 2 || measurements.length === 3) &&
    measurements.every(({ unit }) => unit === "SBP" || unit === "DBP" || unit === "BPM")
  ) {
    return "blood-pressure";
  }

  if (measurements.length === 1) {
    const unit = measurements[0]?.unit;
    if (unit) {
      switch (unit) {
        case "LB":
          return "weight";
        case "Height":
          return "height";
        case "BPM":
          return "heart-rate";
        case "mg/dL":
          return "glucose";
      }
    }
  }

  return "unknown";
};
